import { TipoCalculoRastreamentoEnum } from './parametros-vo';
import {emptyResumoPE, ResumoPlanejadoExecutado} from './resumo-planejado-executado-vo';
import {ResumoPoiVo} from './resumo-poi-vo';
import { TipoGPSEnum } from './rota-vo';

export interface ResumoVo {
  id: string;
  data: string;
  motorista: string;
  placa: string;
  nome: string;
  identificador: string;
  adiantamento?: number;
  executado: ResumoPlanejadoExecutado;
  planejado: ResumoPlanejadoExecutado;
  resumoPOIs: ResumoPoiVo[];
}

export const emptyResumo = (): ResumoVo => ({
  placa: '',
  executado: emptyResumoPE(),
  planejado: emptyResumoPE(),
  identificador: '',
  data: '',
  id: '',
  motorista: '',
  nome: '',
  resumoPOIs: [],
});
